import React from 'react';
import { useLocation } from 'react-router-dom';

const ScrollTop: React.FC = (props) => {
	const { pathname } = useLocation();

	React.useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return <>
		{props.children}
	</>;
};

export default ScrollTop;
